//아코디언
const accSingleTriggers = document.querySelectorAll(".accordion-header");

accSingleTriggers.forEach((trigger) =>
  trigger.addEventListener("click", toggleAccordion)
);

function toggleAccordion() {
  const items = document.querySelectorAll(".accordion-item");
  const thisItem = this.parentNode;

  items.forEach((item) => {
    if (thisItem == item) {
      thisItem.classList.toggle("active");
      return;
    }
    item.classList.remove("active");
  });
}
//video guide
let vtabs = document.querySelectorAll(".video-guides-btns li");
let vtabsArray = Array.from(vtabs);
let vdivs = document.querySelectorAll(".video-guides-contents > div");
let vdivsArray = Array.from(vdivs);

// console.log(vtabsArray);

vtabsArray.forEach((ele) => {
  ele.addEventListener("click", function (e) {
    // console.log(ele);
    vtabsArray.forEach((ele) => {
      ele.classList.remove("active");
    });
    e.currentTarget.classList.add("active");
    vdivsArray.forEach((div) => {
      div.style.display = "none";
    });
    // console.log(e.currentTarget.dataset.cont);
    document.querySelector(e.currentTarget.dataset.cont).style.display = "block";
  });
});

//탭
let tabs = document.querySelectorAll(".tabs li");
let tabsArray = Array.from(tabs);
let divs = document.querySelectorAll(".content > div");
let divsArray = Array.from(divs);

// console.log(tabsArray);

tabsArray.forEach((ele) => {
  ele.addEventListener("click", function (e) {
    // console.log(ele);
    tabsArray.forEach((ele) => {
      ele.classList.remove("active");
    });
    e.currentTarget.classList.add("active");
    divsArray.forEach((div) => {
      div.style.display = "none";
    });
    // console.log(e.currentTarget.dataset.cont);
    document.querySelector(e.currentTarget.dataset.cont).style.display = "block";
  });
});

//스케줄 탭
let stabs = document.querySelectorAll(".schedule-tab-btns li");
let stabsArray = Array.from(stabs);
let sdivs = document.querySelectorAll(".schedule-tab-content > div");
let sdivsArray = Array.from(sdivs);

// console.log(stabsArray);

stabsArray.forEach((ele) => {
  ele.addEventListener("click", function (e) {
    // console.log(ele);
    stabsArray.forEach((ele) => {
      ele.classList.remove("active");
    });
    e.currentTarget.classList.add("active");
    sdivsArray.forEach((div) => {
      div.style.display = "none";
    });
    // console.log(e.currentTarget.dataset.cont);
    document.querySelector(e.currentTarget.dataset.cont).style.display = "block";
  });
});

//슬라이드
 var swiper = new Swiper(".swiper-container", {
  slidesPerView: "auto",
  freeMode: true,
  slideToClickedSlide: true,

});
 var pro_slide = new Swiper(".pro_slide", {
  slidesPerView: "auto",

});
//코드복사

function copy(val) {
  var dummy = document.createElement("textarea");
  document.body.appendChild(dummy);
  dummy.value = val;
  dummy.select();
  document.execCommand("copy");
  document.body.removeChild(dummy);
  alert('Code Copied!');
}

//스파이더스크롤

$(document).ready(function() {
  $(window).scroll(function() {
    var currentSection = null;
    $('section').each(function() {
      var sectionTop = $(this).offset().top - 200; // 50px offset
      if ($(window).scrollTop() >= sectionTop ) {
        currentSection = $(this).attr('id');
      }
    });
    $('.ager-nav-bottom-inner li').removeClass('active');
    if (currentSection) {
      $('.ager-nav-bottom-inner li:has(a[href="#'+ currentSection +'"])').addClass('active');
    }
  });

  var lastId,
 topMenu = $("#mainNav"),
 topMenuHeight = topMenu.outerHeight()+1,
  
 // All list items
 menuItems = topMenu.find("a"),
 // Anchors corresponding to menu items
 scrollItems = menuItems.map(function(){
   var item = $($(this).attr("href"));
    if (item.length) { return item; }
 });

// Bind click handler to menu items
// so we can get a fancy scroll animation
menuItems.click(function(e){
  var href = $(this).attr("href"),
      offsetTop = href === "#" ? 0 : $(href).offset().top-topMenuHeight+1;

  $('html, body').stop().animate({ 
      scrollTop: offsetTop - 70
  }, 850);
  
  e.preventDefault();
});

});

